var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consult-tip",on:{"click":function($event){return _vm.$emit('goConsultant')}}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }